import { Form, Formik } from "formik"
import { ImportBillReceiversFormContent } from "./ImportBillReceiversFormContent"
import { ImportBillReceiversFormValues, ReceiverType, UpdateKeyListBillReceivers } from "../importBillReceiversTypes"
import { ImportCsvFile } from "../../../../../../shared/components/importCsv/importCsvFileTypes"

type ImportBillReceiversFormProps = Readonly<{
    onSubmit: (importData: ImportCsvFile) => void
}>

export const ImportBillReceiversForm = ({ onSubmit }: ImportBillReceiversFormProps) => {
    const defaultInitialValues = {
        receiverType: ReceiverType.FROM_FILE,
        updateKey: UpdateKeyListBillReceivers.TODO,
        updateMatching: false,
        deleteUnmatched: false,
        file: null,
    }

    function handleSubmit({ file, updateMatching, deleteUnmatched, updateKey }: ImportBillReceiversFormValues) {
        file && onSubmit({ file, updateMatching, deleteUnmatched, updateKey })
    }

    return (
        <>
            <Formik<ImportBillReceiversFormValues>
                enableReinitialize
                initialValues={defaultInitialValues}
                onSubmit={handleSubmit}
            >
                <Form>
                    <ImportBillReceiversFormContent />
                </Form>
            </Formik>
        </>
    )
}
